import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { RankingsHubPage } from '~/features/rankings/components/RankingsHubPage'

const rankingsSearchSchema = z.object({
  year: z.coerce.number().int().min(2020).default(2026),
})

export const Route = createFileRoute('/{-$locale}/_public/rankings/')({
  validateSearch: rankingsSearchSchema,
  component: RankingsHubPage,
})
